import { Home, Login } from '../../pages';
import { FileUpdateLayout, Layout } from '../../components';

export default [
	{
		// 登入
		path: '/login',
		title: 'login',
		permission: '',
		requireAuth: false,
		element: (
			<Layout>
				<Login />
			</Layout>
		),
	},
	{
		/* edepot 入口 - Home */
		path: '/',
		title: 'home',
		permission: '',
		requireAuth: false,
		element: (
			<Layout>
				<FileUpdateLayout>
					<Home />
				</FileUpdateLayout>
			</Layout>
		),
	},
];
